import React from 'react';
import { Tier } from '../hooks/useDiagnostic';
const PDF_URL = 'https://avy.me/resources/no-theory-just-the-words-that-matter-avy.pdf';
const BOOKING_URL = 'https://tidycal.com/avy/clarity';
interface ResultScreenProps {
  tier: Tier;
  score: number;
}
const TIER_CONTENT = {
  control: {
    headline: 'You\u2019re probably fine.',
    body: ['You likely understand what\u2019s happening in your projects. You ask questions. You\u2019re not easily led.', 'There may still be room to tighten things up before money is committed.'],
    bookingSubline: 'Bring a live project or something you\u2019re about to start.',
    interpretation: 'You\u2019re likely asking the right questions before decisions are made.'
  },
  clarity: {
    headline: 'Things feel slightly unclear.',
    body: ['You probably follow most of what\u2019s happening, but not all of it. That\u2019s common.', 'It usually means there isn\u2019t a clear plan before the design starts.', 'That\u2019s fixable.'],
    bookingSubline: 'Bring a live project or something you\u2019re about to start.',
    interpretation: 'There\u2019s some structure in place, but not consistently.'
  },
  risk: {
    headline: 'You might be moving on instinct.',
    body: ['If meetings feel hard to challenge and goals aren\u2019t clearly defined, you may be moving ahead without a solid plan.', 'That happens more often than people admit.', 'Before committing more budget, it may be worth reviewing things properly.'],
    bookingSubline: 'Bring a live project or something you\u2019re about to start.',
    interpretation: 'There may be gaps in how projects are being structured before design begins.'
  }
};
export function ResultScreen({
  tier,
  score
}: ResultScreenProps) {
  const content = TIER_CONTENT[tier];
  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
    paddingTop: '1rem'
  }} data-id="element-66">
      {/* Result */}
      <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem'
    }} data-id="element-67">
        {/* Score display */}
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
        border: '1px solid #ef4444',
        borderRadius: '0.375rem',
        padding: '0.75rem 1.5rem',
        minHeight: '56px',
        justifyContent: 'center'
      }} data-id="element-68">
          <p style={{
          fontSize: '1.125rem',
          lineHeight: '1.5',
          color: '#1A1A1A',
          fontWeight: 600
        }} data-id="element-69">
            Your clarity score: {score} out of 15
          </p>
          <p style={{
          fontSize: '1rem',
          lineHeight: '1.6',
          color: '#8A8A85'
        }} data-id="element-70">
            {content.interpretation}
          </p>
        </div>

        <h2 style={{
        fontSize: 'clamp(1.875rem, 4vw, 2.25rem)',
        lineHeight: '1.2'
      }} data-id="element-71">
          {content.headline}
        </h2>
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem'
      }} data-id="element-72">
          {content.body.map((paragraph, idx) => <p key={idx} style={{
          fontSize: '1.125rem',
          lineHeight: '1.7'
        }} data-id="element-73">
              {paragraph}
            </p>)}
        </div>
      </div>

      {/* Actions */}
      <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    }} data-id="element-74">
        <a href={PDF_URL} target="_blank" rel="noopener noreferrer" className="btn-base btn-primary" data-id="element-75">
          Download the guide
        </a>
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem'
      }} data-id="element-76">
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn-base" style={{
          backgroundColor: '#ef4444',
          color: '#FFFFFF',
          border: '1px solid #ef4444'
        }} data-id="element-77">
            Book a 20 Minute Clarity Session
          </a>
          <p style={{
          fontSize: '0.875rem',
          color: '#8A8A85'
        }} data-id="element-78">
            {content.bookingSubline}
          </p>
        </div>
      </div>

      {/* Testimonial */}
      <div className="testimonial-card" style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem'
    }} data-id="element-79">
        <p style={{
        fontSize: '1.125rem',
        fontStyle: 'italic',
        lineHeight: '1.7',
        color: '#1A1A1A'
      }} data-id="element-80">
          "AVY's effective communication and transparency made collaboration
          smooth and seamless."
        </p>
        <p style={{
        fontSize: '0.875rem',
        color: '#8A8A85',
        fontWeight: 500
      }} data-id="element-81">
          — Director, Financial Services
        </p>
      </div>

      {/* Footer line */}
      <div style={{
      paddingTop: '2rem',
      borderTop: '1px solid #E5E5E0'
    }} data-id="element-82">
        <p style={{
        fontSize: '0.875rem',
        color: '#8A8A85',
        lineHeight: '1.6'
      }} data-id="element-83">
          All design work at AVY® starts with a proper gameplan session before
          visuals are created.
        </p>
      </div>
    </div>;
}